import { useAppSelector } from '@redux/hooks';
import { getStrParams, getTemplate, isModelTemplate } from '@entities/Filter';
import { getModels, getPagination, getProducts, useGetListModelsQuery, useGetListProductsQuery } from '@entities/Catalog';
import { selectRegion } from '@redux/slices/header';
import { useSmartQuery } from '@shared/hooks/useSmartQuery';

export const useGetStateProduct = (): {
  totalCount: number;
  productFetching: boolean;
  modelsFetching: boolean;
  isModels?: boolean;
} => {
  const template = useAppSelector(getTemplate);
  const fetchParams = useAppSelector(getStrParams);
  const { REGION: regionId } = useAppSelector(selectRegion);
  const ssrPagination = useAppSelector(getPagination);

  const ssrDataProduct = useAppSelector(getProducts);
  const { data: products, isFetching: productFetching } = useSmartQuery({
    queryHook: useGetListProductsQuery,
    params: { params: fetchParams, regionId: parseInt(regionId) },
    initialData: { data: ssrDataProduct, pagination: ssrPagination },
    isSkip: isModelTemplate(template),
  });
  const ssrDataModel = useAppSelector(getModels);
  const { data: models, isFetching: modelsFetching } = useSmartQuery({
    queryHook: useGetListModelsQuery,
    params: { params: fetchParams, regionId: parseInt(regionId) },
    initialData: { data: ssrDataModel, pagination: ssrPagination },
    isSkip: !isModelTemplate(template),
  });

  const totalCount = isModelTemplate(template) ? models?.pagination?.totalItems : products?.pagination?.totalItems;

  return {
    totalCount,
    productFetching,
    modelsFetching,
    isModels: isModelTemplate(template),
  };
};
